"use client";

import { useRef, useState } from "react";
import Link from "next/link";
import { ArrowRight, Sparkles, Wand2 } from "lucide-react";
import { useT } from "@/components/i18n-ui/provider";

const EXAMPLES = ["balcony", "office", "sourdough", "portugal"] as const;

export function IdeaForm({ signedIn }: { signedIn: boolean }) {
  const t = useT("marketing");
  const [idea, setIdea] = useState("");
  const ref = useRef<HTMLTextAreaElement>(null);
  const action = signedIn ? "/dashboard/sites/new" : "/signup";
  const chooseHref = signedIn ? "/dashboard/sites/new?mode=choose" : `/signup?next=${encodeURIComponent("/dashboard/sites/new?mode=choose")}`;
  return (
    <div>
      <form action={action} method="get" className="group relative rounded-2xl border border-ink-200 bg-white p-2 shadow-[0_1px_2px_rgba(16,24,40,.04),0_24px_48px_-24px_rgba(21,29,81,.25)] transition focus-within:border-brand-300 focus-within:ring-4 focus-within:ring-brand-500/10">
        <label htmlFor="hero-idea" className="sr-only">{t("idea.label")}</label>
        <textarea
          ref={ref}
          id="hero-idea"
          name="idea"
          required
          minLength={3}
          maxLength={500}
          rows={3}
          value={idea}
          onChange={(e) => setIdea(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) e.currentTarget.form?.requestSubmit();
          }}
          placeholder={t("idea.placeholder")}
          className="block w-full resize-none rounded-xl border-0 bg-transparent px-3 py-3 text-base text-ink-900 placeholder:text-ink-400 focus:outline-none focus:ring-0 sm:text-lg"
        />
        <div className="flex flex-col gap-2 border-t border-ink-100 px-1 pt-2 sm:flex-row sm:items-center sm:justify-between">
          <p className="flex items-center gap-1.5 px-2 text-xs text-ink-500">
            <Sparkles className="h-3.5 w-3.5 text-brand-500" aria-hidden /> {t("idea.note")}
          </p>
          <button type="submit" className="btn rounded-xl bg-ink-950 px-5 py-2.5 text-white hover:bg-ink-800">
            {t("idea.submit")} <ArrowRight className="h-4 w-4 rtl:rotate-180" aria-hidden />
          </button>
        </div>
      </form>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <span className="text-xs font-medium text-ink-500">{t("idea.try")}</span>
        {EXAMPLES.map((k) => {
          const ex = t(`idea.examples.${k}`);
          return (
          <button
            key={k}
            type="button"
            onClick={() => {
              setIdea(ex);
              ref.current?.focus();
            }}
            className="rounded-full border border-ink-200 bg-white/70 px-3 py-1 text-xs text-ink-700 transition hover:border-brand-300 hover:text-brand-800"
          >
            {ex}
          </button>
          );
        })}
      </div>
      <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
        <Link href={chooseHref} className="inline-flex items-center gap-1.5 font-medium text-ink-800 underline decoration-ink-300 underline-offset-4 hover:decoration-ink-800">
          <Wand2 className="h-4 w-4 text-violet-600" aria-hidden /> {t("idea.chooseNiche")}
        </Link>
      </div>
    </div>
  );
}
